import { Components, Theme } from "@mui/material";
import { CustomPalette } from "./palette";

export default {
  MuiAlert: {
    styleOverrides: {
      filledInfo: {
        backgroundColor: CustomPalette.primary.main
      },
      root: ({ theme }) => ({
        '& .MuiAlert-message': {
          flexDirection: "column",
          display: "flex",
          color: theme.palette.error.contrastText,
        },
        '& .MuiAlert-icon': {
          alignItems: "center",
          display: "flex",
          color: theme.palette.error.contrastText,
        }
      }),
    }
  }
} as Components<Omit<Theme, "components">>;